import { Action } from '@ngrx/store';
import { IBooking, OldBookingInfo } from '../models/old-booking-infor.model';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

export const SAVE_OLD_BOOKINGS_DATA = 'SAVE_OLD_BOOKINGS_DATA';
export const REFRESH_OLD_BOOKINF_INFO_REDUCER = 'REFRESH_OLD_BOOKINF_INFO_REDUCER';
export const RESET_OLD_BOOKINF_INFO_REDUCER = 'RESET_OLD_BOOKINF_INFO_REDUCER'; //TODO: reset reducer after booking confirmation
export const SAVE_D2D_BOOKINGS_DATA = 'SAVE_D2D_BOOKINGS_DATA';

const initState: OldBookingInfo = {
  abcBooking: null,
  ccdBooking: null,
  d2dReducer: null,
  bookingReducer: null,
  flightFinderReducer: null,
  milesAndMoreReducer: null
}

export function oldBookingInfoReducer(state = initState, action: ActionWithPayloadInterface) {
  switch (action.type) {
    case SAVE_OLD_BOOKINGS_DATA:
      return Object.assign({}, state, { abcBooking: action.payload.abcBooking, ccdBooking: action.payload.ccdBooking });

    case SAVE_D2D_BOOKINGS_DATA:
      return Object.assign({}, state, {
        d2dReducer: action.payload.d2dReducer,
        bookingReducer: action.payload.bookingReducer,
        flightFinderReducer: action.payload.flightFinderReducer,
        milesAndMoreReducer: action.payload.milesAndMoreReducer,
      });

    case REFRESH_OLD_BOOKINF_INFO_REDUCER:
      return Object.assign({}, action.payload);

    case RESET_OLD_BOOKINF_INFO_REDUCER:
      return Object.assign({}, initState);

    default:
      return state;
  }
}
